import { render, staticRenderFns } from "./MotorhomeListingDataChips.vue?vue&type=template&id=15033c8a&scoped=true"
import script from "./MotorhomeListingDataChips.vue?vue&type=script&lang=js"
export * from "./MotorhomeListingDataChips.vue?vue&type=script&lang=js"
import style0 from "./MotorhomeListingDataChips.vue?vue&type=style&index=0&id=15033c8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15033c8a",
  null
  
)

export default component.exports